import React from "react";

type KeywordCardPropstype = {
  isSelected: boolean;
  keyword: string;
  handleSelect: () => void;
  className?: string;
};
function KeywordCard({ isSelected, keyword, handleSelect, className = "" }: KeywordCardPropstype) {
  return (
    <div
      className={`cursor-pointer rounded-full border-blue border py-1 px-4 ${isSelected ? "bg-blue" : "bg-gray-50"} ${className}`}
      onClick={handleSelect}
    >
      <p className={`text-base font-medium ${isSelected ? "text-white" : "text-blue"}`}>
        {keyword}
      </p>
    </div>
  );
}

export default KeywordCard;
